import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, findArrayObject, isEmpty, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import TripActionDialog from './TripActionDialog';
import EditActionIcon from '../../components/Icons/EditActionIcon';
import DeleteActionIcon from '../../components/Icons/DeleteActionIcon';
import {
  getTripDetailsV3,
  getVendorExpense
} from "../../../store/actions/tripActionCreator";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import DeleteVendorCharges from './DeleteTripExpense';
import DeleteVendorDeduction from './DeleteVendorDeduction';
import DeleteVendorPayment from './DeleteVendorPayment';
import DeleteVendorAdvance from './DeleteVendorAdvance';
import AddEditTruckHireCost from './AddEditTruckHireCost';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PaySupplierSideBar from '../RightSideBar/PaySupplierSideBar';
import { getPaymentStatus } from '../../../store/actions/OnlinePaymentActionCreators';
import queryString from "query-string";
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';
import { trackDwebEvent } from '../../analytics';

const useStyles = makeStyles((theme) => ({
  info: {
    padding: '12px 24px',
    borderRadius: 8
  },
  normal: {
    paddingLeft: 0,
    paddingBottom: 5,
    paddingTop: 5
  },
  normalProfit: {
    paddingLeft: 0,
    borderTop: '2px dotted rgba(107, 119, 140, 0.51)'
  },
  nested: {
    paddingLeft: 16,
    paddingBottom: 5,
    paddingTop: 5,
    //paddingRight:24
  },
  primaryNormal: {
    fontSize: 18,
    fontWeight: 600
  },
  primaryNormalParty: {
    fontSize: 18,
    fontWeight: 600,
    color: '#0033cc',
  },
  revenueNormalAmount: {
    color: '#0033cc',
    fontSize: 18
  },
  expenseNormalAmount: {
    color: 'red',
    fontSize: 18
  },
  profitNormalAmount: {
    color: '#008556',
    fontSize: 18
  },
  balanceNormalAmount: {
    color: '#e86825',
    fontSize: 18,
    fontWeight: 600
  },
  primaryNested: {
    fontSize: 16
  },
  primaryFreighNested: {
    fontSize: 16,
    fontWeight: 300
  },
  nestedAmount: {
    fontSize: 18
  },
  nestedAmountV1: {
    fontSize: 18,
    paddingRight: 30
  },
  nestedAmountFreight: {
    fontSize: 16,
    fontWeight: 300
  },
  addTruckHireCost: {
    color: 'white',
    textTransform: 'capitalize',
    backgroundColor: '#0033CC',
    fontWeight: 'bold',
    "&:hover": {
      backgroundColor: '#0033CC'
    }
  },
  checkCircleIconV1: {
    color: '#008556', fontSize: 20, marginLeft: 8
  },
  pdV1: {
    paddingRight: 30
  },
  pdV0: {
    paddingRight: 0
  },
  divAlign: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    marginBottom: 12

  },
  buttonSendMoney: {
    color: 'white',
    fontWeight: 300,
    backgroundColor: '#0033cc',
    textTransform: 'none',
    paddingLeft: 19,
    paddingRight: 18,
    '&:hover': {
      backgroundColor: '#0033cc',
    },
    borderRadius: 4
  },
  mlV1: {
    marginLeft: 14
  }
}));
const VendorSummary = (props) => {
  const classes = useStyles();
  const { location, tripDetails, user, dispatchTripDetailsAction, dispatchGetVendorExpense, dispatchGetPaymentStatus, dispatchAddVendorExpense } = props;
  const [open, setOpen] = React.useState(true);
  const [cashFlowItem, setCashFlowItem] = React.useState(null);
  const [cashFlowType, setCashFlowType] = React.useState(null);
  const [deleteVendorChargeOpen, setDeleteVendorChargeOpen] = useState(false);
  const [deleteVendorDeductionOpen, setDeleteVendorDeductionOpen] = useState(false);
  const [deleteVendorPaymentOpen, setDeleteVendorPaymentOpen] = useState(false);
  const [deleteVendorAdvanceOpen, setDeleteVendorAdvanceOpen] = useState(false);
  const [addEditTruckHireCostOpen, setAddEditTruckHireCostOpen] = useState(false);
  const [hasEditDeleteIcon, setHasEditDeleteIcon] = useState(false);
  const [paySupplier, setPaySupplier] = useState(false);
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [configInfo, setConfigInfo] = useState({});
  const [mixpanelData, setMixpanelData] = useState({});

  useEffect(() => {
    if (tripDetails && tripDetails.vendorTransactions && tripDetails.vendorTransactions.length > 0) {

      tripDetails.vendorTransactions.some((transactions) => {
        if (transactions && transactions.transactionParentType) {
          if (transactions.transactionParentType == "ADVANCE" || transactions.transactionParentType == "DEDUCTION") {
            setHasEditDeleteIcon(true);
            return true;
          } else if (transactions.transactionParentType == "PAYMENT") {
            if (!transactions.is_broker_enabled) {
              setHasEditDeleteIcon(true);
              return true;
            }
          } else {
            setHasEditDeleteIcon(false);
          }
        }

      })

    }

  }, [tripDetails.vendorTransactions]);

  useEffect(() => {

    if (user && user.configs && user.configs.online_payments_config) {
      setConfigInfo(user.configs.online_payments_config);
    } else {
      setConfigInfo({});
    }

  }, [user.configs]);

  const handleClick = () => {
    setOpen(!open);
  };
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorSettled = tripDetails && !isEmpty(tripDetails.isVendorSettled) ? tripDetails.isVendorSettled : tripDetails && tripDetails.vendorBalance && Number(tripDetails.vendorBalance) == 0 ? true : false;
  let hireCostFound = hiredTrip && tripDetails && tripDetails.vendorTransactions && Array.isArray(tripDetails.vendorTransactions) ? tripDetails.vendorTransactions.some((item) => item && item.type == 'Vehicle_Hire_Cost' ? true : false) : true;
  let vendorIdValue = tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "";
  let vendorNameValue = tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "";

  let search = window.location.search;
  const params = queryString.parse(search);
  let orderId = params["order_id"];

  let history = useHistory();

  const [editCashFlowOpen, setEditCashFlowOpen] = useState(false);
  let editVendorCharge = {
    action: 'edit_vendor_charge',
    label: 'Update Charge',
    confirmText: 'Update Charge',
    tabsFormat: false
  }
  let editVendorReduction = {
    action: 'edit_vendor_reduction',
    label: 'Update Deduction',
    confirmText: 'Update Deduction',
    tabsFormat: false
  }
  let editVendorAdvance = {
    action: 'edit_vendor_advance',
    label: 'Update Advance',
    confirmText: 'Update Advance',
    tabsFormat: false
  }
  let editVendorPayment = {
    action: 'edit_vendor_payment',
    label: 'Update Payment',
    confirmText: 'Update Payment',
    tabsFormat: false
  }
  let editTripHireCost = {
    action: 'edit_expense',
    label: 'Update Truck Hire Cost',
    confirmText: 'Update Truck Hire Cost',
    tabsFormat: false
  }

  useEffect(() => {

    if (orderId) {
      dispatchGetPaymentStatus({
        orderId: orderId
      }, (response) => {
        if (response && response.status && response.status.code == 200) {
          setPaySupplier(false);
          if (response.response.message == "Transaction Failed.") {
            handleFailureOpen();
            setTimeout(() => {
              handleFailureClose()
            }, 3000);
          } else {
            handleSuccessOpen();
            setTimeout(() => {
              handleSuccessClose()
            }, 3000);
            trackDwebEvent('Dweb STP Supplier payout successful', {
              trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
              trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
              supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
              supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
              trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
              vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
              vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
              origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
              destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
              supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
              supplier_payout_amount: mixpanelData && mixpanelData.payoutAmount ? mixpanelData.payoutAmount : "",
              bank_account_id: mixpanelData && mixpanelData.bankId ? mixpanelData.bankId : ""
            });
          }
        } else {
          handleFailureOpen();
          setTimeout(() => {
            handleFailureClose()
          }, 3000);
          trackDwebEvent('Dweb STP Supplier payout successful', {
            trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
            trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
            supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
            supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
            trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
            vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
            vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
            origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
            destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
            supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
            supplier_payout_amount: mixpanelData && mixpanelData.payoutAmount ? mixpanelData.payoutAmount : "",
            bank_account_id: mixpanelData && mixpanelData.bankId ? mixpanelData.bankId : "",
            error_response: response && response.response && response.response.message ? response.response.message : ""
          });
        }
      }, () => {
        handleFailureOpen();
        setTimeout(() => {
          handleFailureClose()
        }, 3000);
      })
    }

  }, [
    orderId
  ]);

  const handleEditCashFlow = (event, item, actionType) => {
    let cashflowItem = item;
    if (cashflowItem) {
      setCashFlowItem(cashflowItem);
      setCashFlowType(actionType);
      setEditCashFlowOpen(true);
    }
  }
  const handleAddTruckHireCost = () => {
    setAddEditTruckHireCostOpen(true);
  }
  const handleAddEditTruckHireCostClose = () => {
    fetchTrip(tripId)
    setAddEditTruckHireCostOpen(false);
    resetCashFlow();
  }
  const handleAddEditTruckHireCostSave = () => {
    fetchTrip(tripId)
    setAddEditTruckHireCostOpen(false);
    resetCashFlow();
  }

  const handleEditTruckHireCost = (event, item) => {
    if (item && item.id) {
      dispatchGetVendorExpense(item.id, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          if (response.response && response.response.id) {
            setCashFlowItem(response.response);
            setAddEditTruckHireCostOpen(true);
          }
        }
      }, () => {

      })
    }
  }
  const handleEditCashflowActionClose = (status) => {
    setEditCashFlowOpen(status);
    setCashFlowItem(null);
    setCashFlowType(null);
    fetchTrip(tripId)
  }
  const handleOnUpdateSuccess = (status) => {
    setEditCashFlowOpen(status);
    setCashFlowItem(null);
    setCashFlowType(null);
    fetchTrip(tripId)
  }
  const resetCashFlow = () => {
    setCashFlowItem(null);
    setCashFlowType(null);
  }
  const onDeleteVendorCharge = (event, item) => {
    setCashFlowItem(item);
    setDeleteVendorChargeOpen(true);
  }
  const onVendorChargeDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeleteVendorChargeOpen(false);
    resetCashFlow()
  }
  const onVendorChargeDeleteCancel = () => {
    fetchTrip(tripId)
    setDeleteVendorChargeOpen(false);
    resetCashFlow()
  }
  const onDeleteVendorDdeduction = (event, item) => {
    setCashFlowItem(item);
    setDeleteVendorDeductionOpen(true);
  }
  const onDeleteVendorPayment = (event, item) => {
    setCashFlowItem(item);
    setDeleteVendorPaymentOpen(true);
  }
  const onDeleteVendorAdvance = (event, item) => {
    setCashFlowItem(item);
    setDeleteVendorAdvanceOpen(true);
  }
  const onVendorDeductionDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeleteVendorDeductionOpen(false);
    resetCashFlow()
  }
  const onVendorPaymentDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeleteVendorPaymentOpen(false);
    resetCashFlow()
  }
  const onVendorAdvanceDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeleteVendorAdvanceOpen(false);
    resetCashFlow()
  }
  const onVendorDeductionDeleteCancel = () => {
    fetchTrip(tripId)
    setDeleteVendorDeductionOpen(false);
    resetCashFlow()
  }
  const onVendorPaymentDeleteCancel = () => {
    fetchTrip(tripId)
    setDeleteVendorPaymentOpen(false);
    resetCashFlow()
  }
  const onVendorAdvanceDeleteCancel = () => {
    fetchTrip(tripId)
    setDeleteVendorAdvanceOpen(false);
    resetCashFlow()
  }

  const handleSendMoney = () => {
    setPaySupplier(true);
    trackDwebEvent('Dweb STP Supplier payout initiated', {
      trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
      trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
      supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
      supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
      trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
      vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
      vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
      origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
      destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
      supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : ""
    })
  }

  const handlePaySupplierSideBarClose = (value) => {
    setPaySupplier(false);
    setMixpanelData(value);
  }

  const goToSingleTrip = () => {

    const currentUrl = (window.location.href).split("/");
    const query = (currentUrl[currentUrl.length - 1]).split("?");
    const tripIdValue = query[0];

    history.push({
      pathname: `/trips/view/${tripIdValue}`,
      state: {
        id: 7,
        tripData: tripDetails,
        tripView: true,
        pageTitle: 'Trip Details',
      }
    });
  }

  const handleSuccessOpen = () => {
    setSuccessCreation(true)
  }

  const handleSuccessClose = () => {
    setSuccessCreation(false)
    goToSingleTrip()
  }

  const handleFailureOpen = () => {
    setFailureCreation(true)
  }

  const handleFailureClose = () => {
    setFailureCreation(false)
    goToSingleTrip()
  }


  return (
    <Paper className={classes.info}>
      <List
        component="nav"
        aria-labelledby="profit-summary-list"
        className={classes.root}
      >
        <ListItem className={classes.normal}>
          <ListItemText primary={tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : 'N/A'} classes={{ primary: classes.primaryNormalParty }} />
          {!hireCostFound && <span>
            <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addTruckHireCost} onClick={handleAddTruckHireCost}>
              Truck Hire Cost
            </Button>
          </span>}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {tripDetails && tripDetails.vendorTransactions && tripDetails.vendorTransactions.map((item, index) => {
              return (item.type == 'Vehicle_Hire_Cost' ? <ListItem key={index} className={classes.nested}>
                <ListItemText primary='Truck Hire Cost' classes={{ primary: classes.primaryFreighNested }} />
                <span className={hasEditDeleteIcon ? classes.pdV1 : classes.pdV0}>
                  <span className={classes.nestedAmountFreight}>{numberFormat(tripDetails && tripDetails.truckHireCost ? tripDetails.truckHireCost : 0)}</span>
                  {!vendorSettled && item.id && <><EditActionIcon onClick={(e) => { handleEditTruckHireCost(e, item) }} /></>}
                </span>
              </ListItem> : null)
            })}
            {
              tripDetails && tripDetails.vendorTransactions && tripDetails.vendorTransactions.map((item, index) => {
                return ((item.transactionParentType == 'ADVANCE' && item.type != 'Vehicle_Hire_Cost') ? <ListItem key={index} className={classes.nested}>
                  <ListItemText primary={item.displayName} classes={{ primary: classes.primaryNested }} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{!vendorSettled && item.id && <><EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editVendorAdvance) }} /><DeleteActionIcon onClick={(e) => { onDeleteVendorAdvance(e, item) }} /></>}</span>
                </ListItem> : null)
              })
            }
            {
              tripDetails && tripDetails.vendorTransactions && tripDetails.vendorTransactions.map((item, index) => {
                return ((item.transactionParentType == 'EXPENSE' && item.type != 'Vehicle_Hire_Cost') ? <ListItem key={index} className={classes.nested}>
                  <ListItemText primary={item.displayName} classes={{ primary: classes.primaryNested }} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{!vendorSettled && item.id && <><EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editVendorCharge) }} /><DeleteActionIcon onClick={(e) => { onDeleteVendorCharge(e, item) }} /></>}</span>
                </ListItem> : null)
              })
            }
            {
              tripDetails && tripDetails.vendorTransactions && tripDetails.vendorTransactions.map((item, index) => {
                return ((item.transactionParentType == 'DEDUCTION' && item.type != 'Vehicle_Hire_Cost') ? <ListItem key={index} className={classes.nested}>
                  <ListItemText primary={item.displayName} classes={{ primary: classes.primaryNested }} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{!vendorSettled && item.id && <><EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editVendorReduction) }} /><DeleteActionIcon onClick={(e) => { onDeleteVendorDdeduction(e, item) }} /></>}</span>
                </ListItem> : null)
              })
            }
            {
              tripDetails && tripDetails.vendorTransactions && tripDetails.vendorTransactions.map((item, index) => {
                return ((item.transactionParentType == 'PAYMENT' && item.type != 'Vehicle_Hire_Cost') ? <ListItem key={index} className={classes.nested}>
                  <ListItemText primary={item.displayName} classes={{ primary: classes.primaryNested }} />
                  {item && !item.is_broker_enabled &&
                    <span className={classes.nestedAmount}>{numberFormat(item.amount)}{!vendorSettled && item.id && <><EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editVendorPayment) }} /><DeleteActionIcon onClick={(e) => { onDeleteVendorPayment(e, item) }} /></>}</span>
                  }
                  {item && item.is_broker_enabled &&
                    <span className={hasEditDeleteIcon ? classes.nestedAmountV1 : classes.nestedAmount}>{numberFormat(item.amount)}<CheckCircleIcon className={classes.checkCircleIconV1} /></span>
                  }
                </ListItem> : null)
              })
            }
            {/* {
              tripDetails && tripDetails.vendorCharges && tripDetails.vendorCharges.map((item,index)=>{
                return(<ListItem button className={classes.nested}>
                  <ListItemText primary={item.displayName} classes={{primary:classes.primaryNested}} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}</span>
                </ListItem>)
              })
            }
            {
              tripDetails && tripDetails.vendorDeductions && tripDetails.vendorDeductions.map((item,index)=>{
                return(<ListItem button className={classes.nested}>
                  <ListItemText primary={item.displayName} classes={{primary:classes.primaryNested}} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}</span>
                </ListItem>)
              })
            }
            {
              tripDetails && tripDetails.vendorPayments && tripDetails.vendorPayments.map((item,index)=>{
                return(<ListItem button className={classes.nested}>
                  <ListItemText primary={item.displayName} classes={{primary:classes.primaryNested}} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}</span>
                </ListItem>)
              })
            } */}
          </List>
        </Collapse>
        <ListItem className={classes.normalProfit}>
          <ListItemText primary="Supplier Balance" classes={{ primary: classes.primaryNormal }} />
          <span className={classes.balanceNormalAmount}>{numberFormat(Number(tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : 0))}</span>
        </ListItem>
      </List>
      {tripDetails && tripDetails.vendorBalance != 0 && configInfo.supplierPayout && configInfo.supplierPayout.show == 1 &&
        <div className={classes.divAlign} >
          <Button variant="contained" className={classes.buttonSendMoney} onClick={() => handleSendMoney()} >
            &#8377;<span className={classes.mlV1}>Send Money</span>
          </Button>
        </div>
      }
      {editCashFlowOpen && <TripActionDialog action={cashFlowType} editData={cashFlowItem} open={editCashFlowOpen} onClose={handleEditCashflowActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={cashFlowType.confirmText ? cashFlowType.confirmText : null} />}
      {addEditTruckHireCostOpen && <AddEditTruckHireCost editData={cashFlowItem} open={addEditTruckHireCostOpen} onClose={handleAddEditTruckHireCostClose} onSave={handleAddEditTruckHireCostSave} />}
      {deleteVendorChargeOpen && <DeleteVendorCharges deleteOpen={deleteVendorChargeOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onVendorChargeDeleteSuccess}
        onDeleteNo={onVendorChargeDeleteCancel}
        customMessage="Are you sure Want to Delete a Supplier Charge?"
        customTitle="Delete Supplier Charge"
        successMessage="Supplier Charge Deleted Successfully!"
      />}
      {deleteVendorAdvanceOpen && <DeleteVendorAdvance deleteOpen={deleteVendorAdvanceOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onVendorAdvanceDeleteSuccess} onDeleteNo={onVendorAdvanceDeleteCancel} />}
      {deleteVendorDeductionOpen && <DeleteVendorDeduction deleteOpen={deleteVendorDeductionOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onVendorDeductionDeleteSuccess} onDeleteNo={onVendorDeductionDeleteCancel} />}
      {deleteVendorPaymentOpen && <DeleteVendorPayment deleteOpen={deleteVendorPaymentOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onVendorPaymentDeleteSuccess} onDeleteNo={onVendorPaymentDeleteCancel} />}
      {paySupplier &&
        <PaySupplierSideBar rightSideBarOpen={paySupplier} toggleRightSideBar={handlePaySupplierSideBarClose} tripId={tripId} siderName={"pay-supplier"} calledFromFlow={"singleTrip"} tripDetailSingleTrip={tripDetails} />
      }
      {successCreation && <SuccessDialog open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
      {failureCreation && <FailureDialog open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
    </Paper>
  );
}
const VendorSummaryWithRouter = withRouter(VendorSummary);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
  dispatchGetVendorExpense: (expenseId, onSuccess, onFailure) =>
    dispatch(getVendorExpense(expenseId, onSuccess, onFailure)),
  dispatchGetPaymentStatus: (data, onSuccess, onError) => {
    dispatch(getPaymentStatus(data, onSuccess, onError))
  },

});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorSummaryWithRouter);